module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xs": "",
      "px-0": "",
      "banner": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "text-container pt-md-15 justify-center align-md-start align-center flex-column"
  }, [_c('h3', {
    staticClass: "mb-5"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-btn', {
    staticClass: "discover_btn",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'Login'
        })
      }
    }
  }, [_vm._v("Discover ")])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "img-container d-flex justify-center align-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgSrc
    }
  })])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62b2d2df","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/landingPages/Banner.vue
// module id = 1748
// module chunks = 180